// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Scheduler, SchedulerDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpdateScheduler(): (
  schedulerId: string,
  requestBody: SchedulerDaten
) => Promise<Scheduler> {
  const getAPI = useGetApi();
  return useCallback(
    async (schedulerId, requestBody) =>
      (await getAPI()).schedulers.updateScheduler({ schedulerId, requestBody }),
    [getAPI]
  );
}
